import { useState, useEffect, useRef } from 'react';
import { Tooltip, Table } from '@burna/monster-design-system';
import { copyToClipboard } from 'utils';

const CopyIcon = ({ value }) => {
  const [text, setText] = useState('');
  const [hovered, setHovered] = useState(false);
  const [copied, setCopied] = useState(false);
  const copyTimeoutRef = useRef();
  const tooltipRef = useRef();

  useEffect(
    () => window.addEventListener('mousemove', () => setHovered(false)),
    []
  );

  const updateText = text => {
    setText(text);
    tooltipRef.current?.readjust();
  };

  const handleMove = e => {
    e.stopPropagation();
    setHovered(true);
    if (!copied) {
      updateText('click to copy');
    }
  };

  const handleClick = () => {
    updateText('copied');
    setCopied(true);
    clearTimeout(copyTimeoutRef.current);
    copyTimeoutRef.current = setTimeout(() => setCopied(false), 3000);
    copyToClipboard(value);
  };

  return (
    <>
      <Tooltip
        ref={tooltipRef}
        text={text}
        visible={hovered || copied}
        positions={['right', 'top', 'bottom', 'left']}>
        <Table.ActionIcon
          icon="copy"
          onMouseMove={handleMove}
          onClick={handleClick}
        />
      </Tooltip>
    </>
  );
};

export default CopyIcon;
